import { AgentRunsList } from "@/components/agents/runs/agent-runs-list.tsx";
import { m } from "@/paraglide/messages.js";
import { createFileRoute } from "@tanstack/react-router";
import { pageTitle } from "@/utils/page-title.ts";

export const Route = createFileRoute(
	"/_authenticated/dashboard/agents/$agentId/runs/",
)({
	component: RouteComponent,
	head: () => ({
		meta: [{ title: pageTitle(m.agent_runs_meta_title()) }],
	}),
});

function RouteComponent() {
	const { agentId } = Route.useParams();
	return <AgentRunsList agentId={agentId} />;
}
